<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.shopTypeName" placeholder="请输入商家分类名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="shopTypeName" label="分类名称" align="center">
				</el-table-column>
				<el-table-column prop="shopTypeSort" label="排序" align="center">
				</el-table-column>
				
				<el-table-column fixed="right" label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="分类名称" label-width='100px'>
					<el-input v-model="form.shopTypeName" maxlength="18" autocomplete="off" placeholder="请输入用户名"></el-input>
				</el-form-item>
				
				
				<el-form-item label="分类图标" label-width='100px'>
					<el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'"
						:headers="headers" 
						accept=".png,.jpg"
						:on-error='onError'
						:show-file-list="false" :on-success="handleAvatarSuccess">
						<img v-if="form.shopTypeIcon" :src="webUrl+form.shopTypeIcon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<!-- <el-input v-model="form.sort"  autocomplete="off" ></el-input> -->
					<div style="color: red;">请上传1:1的图片比例</div>
				</el-form-item>
				<el-form-item label="分类排序" label-width='100px'>
					<el-input v-model.number="form.shopTypeSort" maxlength="10" autocomplete="off" placeholder="请输入昵称"></el-input>
				</el-form-item>
				

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				roleOptions: [],
				selectTableData: [],
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				webUrl: this.webUrl,
				headers:{
					'token':this.$store.state.token,
					// 'Content-Type': 'multipart/form-data'
				},
				secah: {
					pageSize: 10,
					pageNum: 1,
					shopTypeName: ""
				},
				form: {
					shopTypeSort:"",
					shopTypeName:"",
					shopTypeId:"",
					shopTypeIcon:""
				},

			}
		},
		created() {
			this.getList()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getList()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form={
					shopTypeSort:"",
					shopTypeName:"",
					shopTypeId:"",
					shopTypeIcon:""
				}
			},
			//上传封面图片回调
			handleAvatarSuccess(res, file) {
				this.form.shopTypeIcon = res.data.path
			},
			onError(){
				this.$message.error("上传失败")
			},
			//提交
			sub(){
				if (this.form.shopTypeName.length == 0) {
					this.$message('请输入分类名称');
					return false
				}
				if(this.form.shopTypeSort.length!=0){
					if (!this.isNullNum(this.form.shopTypeSort)) {
						this.$message('排序请输入为数字');
						return false
					}
				}
				var url=this.isAdd?"/pc/shopType/add":"/pc/shopType/update"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getList()
						}
					})
				}else{
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getList()
						}
					})
				}
				
			},
			
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/pc/shopType/del?"+this.$qs.stringify({shopTypeId:row.shopTypeId})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getList()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form=JSON.parse(JSON.stringify(row))
				// this.form.password=''
				
			},
			

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getList()
			},
			//获取数据
			getList() {
				this.httpPost("/pc/shopType/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},
			

		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
